const unitMeasureFields = [
  {
    editable: true,
    isSortable: true,
    name: 'name',
    key: 'name',
    label: 'Satuan',
    placeholder: 'Satuan Dasar',
    validation: 'required',
    type: 'text',
  },
]

export default unitMeasureFields